var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecificFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "86px",
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Copy",
    transform: "translate(-125.000000, -254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(126.000000, 255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "access",
    stroke: "#3B5998"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    rx: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "comment-alt-lines",
    transform: "translate(14.000000, 14.000000)",
    fill: "#3B5998",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.875,0 L7.125,0 C3.19511719,0 0,3.19511719 0,7.125 L0,39.1875 C0,43.1173828 3.19511719,46.3125 7.125,46.3125 L17.8125,46.3125 L17.8125,55.6640625 C17.8125,56.4544922 18.4582031,57 19.1484375,57 C19.415625,57 19.6939453,56.9220703 19.9388672,56.7328125 L33.84375,46.3125 L49.875,46.3125 C53.8048828,46.3125 57,43.1173828 57,39.1875 L57,7.125 C57,3.19511719 53.8048828,0 49.875,0 Z M53.4375,39.1875 C53.4375,41.146875 51.834375,42.75 49.875,42.75 L32.6525391,42.75 L31.70625,43.4625 L21.375,51.2109375 L21.375,42.75 L7.125,42.75 C5.165625,42.75 3.5625,41.146875 3.5625,39.1875 L3.5625,7.125 C3.5625,5.165625 5.165625,3.5625 7.125,3.5625 L49.875,3.5625 C51.834375,3.5625 53.4375,5.165625 53.4375,7.125 L53.4375,39.1875 Z M31.171875,26.71875 L15.140625,26.71875 C14.6507812,26.71875 14.25,27.1195312 14.25,27.609375 L14.25,29.390625 C14.25,29.8804687 14.6507812,30.28125 15.140625,30.28125 L31.171875,30.28125 C31.6617187,30.28125 32.0625,29.8804687 32.0625,29.390625 L32.0625,27.609375 C32.0625,27.1195312 31.6617187,26.71875 31.171875,26.71875 Z M41.859375,16.03125 L15.140625,16.03125 C14.6507812,16.03125 14.25,16.4320312 14.25,16.921875 L14.25,18.703125 C14.25,19.1929688 14.6507812,19.59375 15.140625,19.59375 L41.859375,19.59375 C42.3492187,19.59375 42.75,19.1929688 42.75,18.703125 L42.75,16.921875 C42.75,16.4320312 42.3492187,16.03125 41.859375,16.03125 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecificFeedback);
export default __webpack_public_path__ + "static/media/specific-feedback.88d2dc32ceee8febe7703e483530bff8.svg";
export { ForwardRef as ReactComponent };